<div
  class="progress-bar-container"
  [class.loading]="isLoading"
  [matTooltip]="tooltip$ | async"
  matTooltipClass="multi-line-tooltip"
>
  <div
    *ngFor="let category of categories"
    class="progress-item"
    [style.width.%]="category.percentage"
    [style.background-color]="category.color"
  ></div>
</div>
